<!-- Hero Section -->
<div class="hero-section">
    <div class="hero-overlay"></div>
    <div class="hero-content">
        <h1 class="hero-title">Explore Insights, Research & Media from Virsa</h1>
        <!-- <p class="hero-subtitle">
            Your central hub for blogs, case studies, brochures, and demo videos designed to empower educators and
            institutions.
        </p> -->
    </div>
</div>

<!-- Blog Articles Section -->
<section class="section blog-section">
    <div class="container">
        <div class="section-header text-center">
            <h2 class="section-title">EdTech Blog – <span>Trends, Tips & Expert Insights</span></h2>
            <div class="title-underline"></div>
        </div>
        <div class="grid-layout blog-grid">
            <div class="card blog-card" *ngFor="let article of blogArticles">
                <div class="card-image">
                    <img [routerLink]="article.link" [src]="article.image" [alt]="article.title">
                </div>
                <div class="card-content">
                    <h3 [routerLink]="article.link" class="card-title">{{ article.title }}</h3>
                    <p class="card-summary">{{ article.summary }}</p>
                    <a [routerLink]="article.link" class="btn-link">Read More <mat-icon>arrow_forward</mat-icon></a>
                </div>
            </div>
        </div>

        <!-- Pagination Controls -->
        <div class="pagination-container" *ngIf="totalPages > 1">
            <button class="pagination-btn prev-btn" [disabled]="currentPage === 1" (click)="prevPage()">
                <mat-icon>chevron_left</mat-icon> Previous
            </button>
            <div class="pagination-numbers">
                <button *ngFor="let page of pagesArray" 
                        class="pagination-number-btn" 
                        [class.active]="currentPage === page"
                        (click)="goToPage(page)">
                    {{ page }}
                </button>
            </div>
            <button class="pagination-btn next-btn" [disabled]="currentPage === totalPages" (click)="nextPage()">
                Next <mat-icon>chevron_right</mat-icon>
            </button>
        </div>
    </div>
</section>

<!-- Case Studies Section -->
<!-- <section class="section case-studies-section">
    <div class="container">
        <div class="section-header text-center">
            <h2 class="section-title">Real Success Stories from <span>Our Clients</span></h2>
            <div class="title-underline"></div>
        </div>
        <div class="grid-layout case-study-grid">
            <div class="card case-study-card" *ngFor="let study of caseStudies">
                <div class="card-image">
                    <img [src]="study.image" [alt]="study.schoolName">
                    <div class="overlay">
                        <span class="school-name">{{ study.schoolName }}</span>
                    </div>
                </div>
                <div class="card-content">
                    <p class="details">{{ study.details }}</p>
                    <p class="summary">{{ study.summary }}</p>
                    <a [href]="study.link" class="btn-primary">View Case Study</a>
                </div>
            </div>
        </div>
    </div>
</section> -->

<!-- Brochures Section -->
<section class="section brochures-section">
    <div class="container">
        <div class="section-header text-center">
            <h2 class="section-title">Download Brochures & <span>Product Catalogues</span></h2>
            <div class="title-underline"></div>
        </div>
        <div class="grid-layout brochures-grid">
            <div class="card brochure-card" *ngFor="let brochure of brochures">
                <div class="icon-wrapper">
                    <mat-icon>picture_as_pdf</mat-icon>
                </div>
                <div class="card-content">
                    <h3 class="card-title">{{ brochure.title }}</h3>
                    <p class="card-description">{{ brochure.description }}</p>
                    <a [href]="brochure.link" [attr.download]="brochure.fileName || null"
                        [class.disabled]="!brochure.fileName" target="_blank" class="btn-outline">
                        Download PDF <mat-icon>download</mat-icon>
                    </a>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Video Gallery Section -->
<!-- <section class="section video-section">
    <div class="container">
        <div class="section-header text-center">
            <h2 class="section-title">Video Library – <span>Demo & Product Walkthroughs</span></h2>
            <div class="title-underline"></div>
        </div>
        <div class="grid-layout video-grid">
            <div class="card video-card" *ngFor="let video of videos">
                <div class="video-thumbnail">
                    <img [src]="video.thumbnail" [alt]="video.title">
                    <div class="play-button">
                        <mat-icon>play_circle_filled</mat-icon>
                    </div>
                </div>
                <div class="card-content">
                    <h3 class="card-title">{{ video.title }}</h3>
                </div>
            </div>
        </div>
    </div>
</section> -->